import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/VisitHistoryManagement';

const GetExhibitionViewerReducer = handleActions({
    [Actions.GetExhibitionViewerRequested]: (state) => ({
        ...state,
        isFetching: true,
        errors: {},
        success: false,
    }),
    [Actions.GetExhibitionViewerRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.GetExhibitionViewerRequestedReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.GetExhibitionViewerClear]: () => ({
        isFetching: false,
        data: '',
        errors: {},
        success: false,
    }),
}, {
    isFetching: false,
    data: '',
    errors: {},
    success: false,
});

const GetSeminarViewerReducer = handleActions({
    [Actions.GetCSVSeminarViewerRequested]: (state) => ({
        ...state,
        isFetching: true,
        success: false,
    }),
    [Actions.GetCSVSeminarViewerRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,

    }),
    [Actions.GetCSVSeminarViewerRequestedReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.GetSeminarViewerClear]: () => ({
        isFetching: false,
        data: '',
        errors: {},
        success: false,
    }),
}, {
    isFetching: false,
    data: '',
    errors: {},
    success: false,
});

const GetLivestreamViewerReducer = handleActions({
    [Actions.GetCSVLivestreamViewerRequested]: (state) => ({
        ...state,
        isFetching: true,
        success: false,
    }),
    [Actions.GetCSVLivestreamViewerRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,

    }),
    [Actions.GetCSVLivestreamViewerRequestedReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.GetLivestreamViewerClear]: () => ({
        isFetching: false,
        data: '',
        errors: {},
        success: false,
    }),
}, {
    isFetching: false,
    data: '',
    errors: {},
    success: false,
});

const GetGrandBoothViewerReducer = handleActions({
    [Actions.GetCSVGrandBoothViewerRequested]: (state) => ({
        ...state,
        isFetching: true,
        success: false,
    }),
    [Actions.GetCSVGrandBoothViewerRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,

    }),
    [Actions.GetCSVGrandBoothViewerRequestedReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.GetGrandBoothViewerClear]: () => ({
        isFetching: false,
        data: '',
        errors: {},
        success: false,
    }),
}, {
    isFetching: false,
    data: '',
    errors: {},
    success: false,
});

export default combineReducers({
    getExhibitionViewer: GetExhibitionViewerReducer,
    getSeminarViewer: GetSeminarViewerReducer,
    getLivestreamViewer: GetLivestreamViewerReducer,
    getGrandBoothViewer: GetGrandBoothViewerReducer,
});
